/**
 * @file 如何学习
 * @author 陈恩浩
 */

import React, { Component } from "react";
import { Footer } from "../../components/basic/index";
import "./index.scss";

import { changePopup } from "src/redux/basicInfo";
import { connect } from "react-redux";

@connect((state) => state, { changePopup })
class How extends Component {
  constructor(props) {
    super(props);
    this.state = {
      url: {
        mac: "//download.eeo.cn/client/classin_mac_install_4.0.2.29h3_s.dmg",
        win: "//download.eeo.cn/client/classin_win_install_4.0.2.29h3_s.exe",
      },
    };
  }

  handleDownload = (e) => {
    window.open(`//${e}`);
  };

  handleCheck = (e) => {
    // console.log(e);
    switch (Number(e)) {
      case 0:
        this.props.changePopup({ type: "trial", status: true });
        break;
      case 2:
        let btn = document.getElementById("download");
        document.documentElement.scrollTop =
          btn.getBoundingClientRect().height - 80;
        break;

      default:
        break;
    }
  };

  componentDidMount() {}

  render() {
    let { url } = this.state,
      applyList = [
        {
          text:
            "注册后您可以领取到价值188元的试听大礼包，您将免费获得一次中文水平测试、一节一对一试读体验课、一份专属学习方案、海量中文学习资源...",
          btn: "立即申请",
          // inp: true
          inp: false,
        },
        {
          text:
            "我们的专业课程顾问会尽快与您联系，引导您和孩子进行中文水平测试，并为您安排试读体验课",
          btn: "立即联系",
          inp: false,
        },
        {
          text: "点击下载客户端，进入哈兔在线教室，开始上课吧",
          btn: "立即下载",
          inp: false,
        },
      ],
      claimList = [
        { text: "台式电脑+摄像头+头戴式耳麦" },
        { text: "笔记本电脑(内置或外接摄像头)+头戴式耳麦" },
        { text: "苹果台式电脑或苹果笔记本电脑" },
        { text: "iPad(5代以上且ios9.0版本)" },
      ];
    return (
      <div className="howTeach">
        <div className="banner"></div>
        <div className="inner">
          <div className="apply">
            <div className="inner-title">申请试听课</div>
            {applyList.map((item, index) => (
              <div className="apply-layout" key={index}>
                <div className="num"></div>
                <div className="info">
                  <div className="text">{item.text}</div>
                  <div className="form">
                    {item.inp && (
                      <input
                        placeholder="请输入您的手机号，立即领取"
                        className="inp"
                      />
                    )}
                    <div
                      className="btn"
                      onClick={() => this.handleCheck(index)}
                    >
                      {item.btn}
                      {Number(index) === 1 && (
                        <div className="btn-qrcode"></div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div id="download" className="download">
            <div className="inner-title">下载课堂用户端</div>
            <div className="download-layout-1">
              {/* <div className='icon'>下载地址</div> */}
              <div className="img"></div>
              <div className="info">
                <div className="title">哈兔课堂PC客户端</div>
                <div className="desc" style={{ marginBottom: 0 }}>
                  使用哈兔客户端上课，让您的在线课堂体验更高效、便捷、稳定。
                </div>
                <div className="desc" style={{ marginTop: "18px" }}>
                  不支持XP系统，要求Mac10.10或Windows 7.0以上iOS 9.0 以上
                </div>
                <div className="btn">
                  <div
                    className="btn-mac"
                    onClick={() => this.handleDownload(url.mac)}
                  >
                    Mac 下载
                  </div>
                  <div
                    className="btn-win"
                    onClick={() => this.handleDownload(url.win)}
                  >
                    Windows 下载
                  </div>
                </div>
              </div>
            </div>
            <div className="download-layout-2">
              <div className="info">
                <div className="title">哈兔课堂移动端</div>
                <div className="btn">App下载</div>
              </div>
              <div className="img">
                <img
                  alt="img"
                  width="114px"
                  src="//cdn.ihatoo.com/hatu-official/public/download_qrcode.png"
                />
              </div>
              <div className="icon"></div>
            </div>
            <div className="download-layout-3">
              <div className="layout-left">
                <video className="video" controls>
                  <source
                    src="//hatu-cdn.oss-cn-hangzhou.aliyuncs.com/hatu-official/course/video/class.mp4"
                    type="video/mp4"
                  />
                </video>
                <div className="text">
                  不支持XP系统，要求Mac10.10或Windows 7.0以上iOS 9.0 以上
                </div>
              </div>
              <div className="layout-right"></div>
            </div>
          </div>
          <div className="claim">
            <div className="inner-title">上课设备要求</div>
            <ul className="claim-layout">
              {claimList.map((item, index) => (
                <li className="claim-list" key={index}>
                  <div className="img"></div>
                  <div className="text">{item.text}</div>
                </li>
              ))}
            </ul>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default How;
